import { Close as CloseIcon } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../../shared/source/context/context';
import { Headline, SubTitle } from '../../../../design/components/Typography';

import type { FunctionComponent, PropsWithChildren } from 'react';

type VisibilityFormWrapperProperties = PropsWithChildren & {
    readonly onClose: () => void;
};

export const VisibilityFormWrapper: FunctionComponent<VisibilityFormWrapperProperties> = ({ children, onClose }) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Grid>
            <Grid alignItems="center" container={true} justifyContent="space-between" minHeight={64} paddingX={3}>
                <Headline variant="h5">{translate('pages.user-profile.profile-visibility.drawer.title')}</Headline>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Grid>
            <Divider />
            <Grid mx={3} my={2}>
                <Headline variant="h5">
                    {translate('pages.user-profile.profile-visibility.drawer.sections.headline')}
                </Headline>
                <Grid container={true} gap={1}>
                    <SubTitle>{translate('pages.user-profile.profile-visibility.drawer.sections.subtitle')}</SubTitle>
                </Grid>
            </Grid>
            {children}
        </Grid>
    );
};
